import adminApiClient from '../api/adminApiClient'
import type { UserResponse, UserCreateRequest, UserUpdateRequest } from '../types'

interface UsersFilter {
  branchId?: string
  role?: string
  archived?: boolean
}

export async function getUsers(filter?: UsersFilter): Promise<UserResponse[]> {
  const { data } = await adminApiClient.get<UserResponse[]>('/users', { params: filter })
  return data
}

export async function getUser(id: string): Promise<UserResponse> {
  const { data } = await adminApiClient.get<UserResponse>(`/users/${id}`)
  return data
}

export async function createUser(body: UserCreateRequest): Promise<UserResponse> {
  const { data } = await adminApiClient.post<UserResponse>('/users', body)
  console.log(`[INFO] User created — id: ${data.id}, login: ${data.login}`)
  return data
}

export async function updateUser(id: string, body: UserUpdateRequest): Promise<UserResponse> {
  const { data } = await adminApiClient.put<UserResponse>(`/users/${id}`, body)
  console.log(`[INFO] User updated — id: ${id}`)
  return data
}

export async function activateUser(id: string): Promise<void> {
  await adminApiClient.put(`/users/${id}/activate`)
  console.log(`[INFO] User activated — id: ${id}`)
}

export async function deactivateUser(id: string): Promise<void> {
  await adminApiClient.put(`/users/${id}/deactivate`)
  console.log(`[INFO] User deactivated — id: ${id}`)
}

export async function archiveUser(id: string): Promise<void> {
  await adminApiClient.post(`/users/${id}/archive`)
  console.log(`[INFO] User archived — id: ${id}`)
}

export async function resetUserPassword(id: string): Promise<void> {
  await adminApiClient.post(`/users/${id}/reset-password`)
  console.log(`[INFO] Password reset email sent — userId: ${id}`)
}
